import * as turfHelpers from "@turf/helpers";
import * as VesselUtil from "@/utils/VesselUtil";
import {MappingTableMixin} from "@/mixins/addon/secure-dataflow";
import moment from "moment-timezone";
import {MAP_DEFAULT_POSITION} from "@/config/const";
import { findLastIndex } from "lodash";

export default {
  isExistsChannelDataManeuvering: state => {
    return state.channelDataManeuvering !== null;
  },

  getMonitoringVesselGeoPoint: (state, getters) => {
    let coordinates = getters.getCoordinates
    return {
      latitude: coordinates[0],
      longitude: coordinates[1]
    };
  },

  getMonitoringVesselInfo: (state, getters) => {
    let coordinates = getters.getCoordinates
    return {
      operationMode: state.channelDataManeuvering.SB44.vs,
      steeringMode: state.channelDataManeuvering.SB29.vs,
      maneuveringMode: state.channelDataManeuvering.SB30.vs,
      latitude: coordinates[0],
      longitude: coordinates[1],
      vesselHeading: state.channelDataManeuvering.SB11.vn,
      speedOverGroundPrecise: state.channelDataManeuvering.SB05.vn,
      distanceFromBowToBerth: state.channelDataManeuvering.SB45.vn,
      distanceFromSternToBerth: state.channelDataManeuvering.SB46.vn,
      datetime: state.channelDataManeuvering.SB02.timestamp
    };
  },

  getMonitoringVesselPositionFeatureCollection: (state, getters) => {
    let coordinates = getters.getCoordinates
    let properties = {
      operationMode: state.channelDataManeuvering.SB44.vs,
      steeringMode: state.channelDataManeuvering.SB29.vs,
      maneuveringMode: state.channelDataManeuvering.SB30.vs,
      latitude: coordinates[0],
      longitude: coordinates[1],
      vesselHeading: state.channelDataManeuvering.SB11.vn,
      speedOverGroundPrecise: state.channelDataManeuvering.SB05.vn,
      icon: MappingTableMixin.methods.getIcon(
        state.channelDataManeuvering.SB44.vs
      )
    };

    let pointFeature = turfHelpers.point([coordinates[1], coordinates[0]], properties);
    return turfHelpers.featureCollection([pointFeature]);
  },

  getSeaRouteFeatureCollection: (state, getters) => {
    if (state.nextArrivalPoint === null) return null;
    let coordinates = [];
    let multiPtFeature = [];
    let lineStringFeatures = [];
    state.seaRoutes.forEach((v, index) => {
      let coordinate = [v.longitude, v.latitude];
      coordinates.push(coordinate);
      let pointProps = {routeName: v.name};
      if (state.nextArrivalPoint.number_of_point <= index && !state.isArrivedPoint) {
        pointProps["icon"] = "sdf-route-point-not-pass-12";
        pointProps["nameColor"] = "#BDBDBD";
      } else {
        pointProps["icon"] = "sdf-route-point-pass-12";
        pointProps["nameColor"] = "#78FACE";
      }
      pointProps["routeNumber"] = v.properties.number_of_point;
      multiPtFeature.push(turfHelpers.point(coordinate, pointProps));
    });

    let prePosition = null;
    coordinates.forEach((position, index) => {
      if (!prePosition) {
        prePosition = position;
      } else {
        let lineProps;
        if (
          state.nextArrivalPoint.number_of_point <= index &&
          !state.isArrivedPoint
        ) {
          lineProps = {
            color: "#BDBDBD",
            isDottedLine: true
          };
        } else {
          lineProps = {
            color: "#78FACE",
            isDottedLine: false
          };
        }

        let linestringFeature = turfHelpers.lineString(
          [prePosition, position],
          lineProps
        );
        lineStringFeatures.push(linestringFeature);
        prePosition = position;
      }
    });

    let featureCollection = turfHelpers.featureCollection([]);
    multiPtFeature.forEach(v => {
      featureCollection.features.push(v);
    });
    lineStringFeatures.forEach(v => {
      featureCollection.features.push(v);
    });

    return featureCollection;
  },

  getOtherVesselsPosition: state => {
    let multiPtFeature = [];
    state.otherVesselsPosition.forEach(v => {
      if (typeof v.info  !== "undefined") {
        let coordinate = [v.position.l.longitude, v.position.l.latitude];
        let diff = moment.utc().unix() - v.info.t / 1000;
        let icon = VesselUtil.getSymbolIconNameLightWeight(
          v.info.c,
          v.info.v,
          diff
        );
        let heading = v.position.h;
        multiPtFeature.push(
          turfHelpers.point(coordinate, {
            vesselName: typeof v.info.n_j !== "undefined" ? v.info.n_j : v.info.n,
            icon: icon,
            heading: heading
          })
        );
      }
    });
    return turfHelpers.featureCollection(multiPtFeature);
  },

  getTrackLineFeatureCollection: state => {
    let coordinates = [];
    if (state.trackPositions.length < 2) {
      return turfHelpers.featureCollection([]);
    }
    state.trackPositions.forEach(v => {
      coordinates.push([v.longitude, v.latitude]);
    });
    let linestringFeature = turfHelpers.lineString(coordinates, {});
    return turfHelpers.featureCollection([linestringFeature]);
  },

  getGhostPositionsFeatureCollection: (state, getters) => {
    if (state.ghostPositions.length === 0) {
      return turfHelpers.featureCollection([]);
    }
    let pastFeature = [];
    let rootTime = moment(
      state.ghostPositions[state.ghostPositions.length - 1].datetime
    );
    state.ghostPositions.forEach((v, index) => {
      let coordinate = [v.longitude, v.latitude];
      if (index !== state.ghostPositions.length - 1) {
        let icon = MappingTableMixin.methods.getIcon(v.operationMode);
        pastFeature.push(
          turfHelpers.point(coordinate, {
            timeDiff: `${moment(v.datetime).diff(rootTime, "m")} min`,
            heading: Number(v.vesselHeading),
            icon: `${icon}-ghost`
          })
        );
      }
    });
    return turfHelpers.featureCollection(pastFeature);
  },

  getCurrentGhostPositions: state => {
    if (state.ghostPositions.length === 0) return null;
    return state.ghostPositions[state.ghostPositions.length - 1];
  },

  getVirtualQuayFeatureCollection: state => {
    return turfHelpers.lineStrings(state.virtualQuayPositions);
  },

  getPassingTime: state => routeNumber => {
    const target = state.veeringPoints.find(v => v.number_of_point === routeNumber);
    if (target) {
      return moment
        .utc(target.actual_time)
        .local()
        .format("YYYY/MM/DD HH:mm:ss");
    }
  },

  getSeaRouteInfo: state => routeNumber => {
    if (!state.veeringPoints) return
    let veeringPoints = state.veeringPoints.find(v => {
      return v.number_of_point === routeNumber
    });
    if (typeof veeringPoints === "undefined") return

    let isPassing = state.passingPoints.find(v => v === routeNumber);
    let seaRoutesPoints = state.seaRoutes.find(
      v => v.properties.number_of_point === routeNumber
    );
    if (isPassing) {
      let passingTime = "---"
      if(typeof veeringPoints.actual_time !== "undefined" && veeringPoints.actual_time !== null) {
        passingTime = moment
          .utc(veeringPoints.actual_time)
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      }
      let passingEstimatedTime = "---"
      if(typeof veeringPoints.target_time !== "undefined" && veeringPoints.target_time !== null) {
        passingEstimatedTime = moment
          .utc(veeringPoints.target_time)
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      }
      return {
        isPassing: true,
        coordinates: [seaRoutesPoints.longitude, seaRoutesPoints.latitude],
        passingEstimatedTime: passingEstimatedTime,
        passingTime: passingTime
      };
    } else {
      let passingEstimatedTime

      if (veeringPoints.target_time) {
        passingEstimatedTime = moment
          .utc(veeringPoints.target_time)
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        passingEstimatedTime = "---"
      }
      let operationMode = MappingTableMixin.methods.getSBXOperationModeLabelByNumber(
        seaRoutesPoints.properties.operation_mode
      );
      let veeringMethod = MappingTableMixin.methods.getVeeringMethodLabel(
        seaRoutesPoints.properties.veering_method
      );
      if ("T" === seaRoutesPoints.properties.veering_method) {
        let turnRate = `${seaRoutesPoints.properties.turn_rate || "---"}°/分`;
        return {
          isPassing: false,
          isTurnRate: true,
          coordinates: [seaRoutesPoints.longitude, seaRoutesPoints.latitude],
          passingEstimatedTime: passingEstimatedTime,
          operationMode: operationMode,
          veeringMethod: veeringMethod,
          turnRate: turnRate
        };
      } else if ("R" === seaRoutesPoints.properties.veering_method) {
        let turnRadius = `${seaRoutesPoints.properties.turn_radius || "---"}nm`;
        return {
          isPassing: false,
          isRadius: true,
          coordinates: [seaRoutesPoints.longitude, seaRoutesPoints.latitude],
          passingEstimatedTime: passingEstimatedTime,
          operationMode: operationMode,
          veeringMethod: veeringMethod,
          turnRadius: turnRadius
        };
      }
    }
  },
  isSteadyOrInland: state => {
    if (!state.channelDataManeuvering.SB44.vs) return true
    let mode = state.channelDataManeuvering.SB44.vs;
    return mode === "N" || mode === "I"; // 定常航海 or 内海
  },
  idDepartureOrBerthing: state => {
    if (!state.channelDataManeuvering.SB44.vs) return false
    let mode = state.channelDataManeuvering.SB44.vs;
    return mode === "B" || mode === "U" || mode === "A"; // 着岸 or 離岸 or 停泊
  },
  getAlertList: state => {
    return state.channelDataEngine
  },
  getZoomLevelByOperationMode: state => operationMode => {
    if (operationMode === "N") return 10 // 定常航海: zoom:10
    if (operationMode === "I") return 12 // 内海: zoom:12
    if (operationMode === "K") return 14 // 狭水道: zoom:14
    if (operationMode === "P") return 15 // 港内: zoom:15
    return 17 // 着岸//離岸/停泊: zoom:17
  },
  getCoordinates: (state, getters, rootState, rootGetters) =>{
    let latitude
    let longitude
    if (state.channelDataManeuvering.SB03.vn === null) {
      if (state.channelDataManeuvering.SB08.vn === null) {
        latitude = MAP_DEFAULT_POSITION.center[1]
        longitude = MAP_DEFAULT_POSITION.center[0]
      } else {
        latitude = state.channelDataManeuvering.SB07.vn
        longitude = state.channelDataManeuvering.SB08.vn
      }
    } else {
      latitude = state.channelDataManeuvering.SB02.vn
      longitude = state.channelDataManeuvering.SB03.vn
    }
    return [latitude, longitude]
  },
  isGhosToBeUpdated(_state, getters) {
    const ret = getters.junmpingGhostPosition !== -1;
    return ret;
  },
  // 2分以上とびとびになっているghostPositionの位置のうち、最も新しいのものを探す
  junmpingGhostPosition(state, getters) {
    const ghostPositions = state.ghostPositions;
    if (getters.isSteadyOrInland) return -1;
    if (ghostPositions.length === 0) return -1;
    // if(!state.beforeDisplayGhostDatetime) return -1;

    const toBeUpdated = findLastIndex(ghostPositions, function (current, index) {
      const nextIndex = index + 1;
      const isLastIndex = nextIndex === ghostPositions.length;
      const nextDatetime = isLastIndex
        ? state.beforeUpdatingGhostByApiDatetime || moment.utc()
        : ghostPositions[nextIndex] && ghostPositions[nextIndex].datetime;
      if (!nextDatetime) return false;

      const dateFrom = moment(current.datetime);
      const dateTo = moment(nextDatetime);
      const diff = dateTo.diff(dateFrom, "m");
      const isTobBeUpdated = diff >= 2;
      return isTobBeUpdated;
    });
    return toBeUpdated;
  },
  // 2分以上とびとびになっているtrackPositionの位置のうち、最も新しいのものを探す
  jumpingTrackPosition(state, getters) {
    if (!getters.isGhosToBeUpdated) return -1;
    const trackPositions = state.trackPositions;
    const jumpingDatetime =
      state.ghostPositions[getters.junmpingGhostPosition].datetime;

    const toBeUpdated = findLastIndex(trackPositions, function (current) {
      return current.datetime === jumpingDatetime;
    });
    return toBeUpdated;
  },
};
